import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import DateTime from '@square/dashboard-data/models/squareup/common/time/date-time';
export default ProtoBaseModel.extend({
  effectiveAt: attr(DateTime),
  planToken: attr(String),
  planName: attr(String)
});